import {
  Identifiable,
  Project,
  ProjectResource,
  Resource,
  Role,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

function saveProjectResource(httpClient: HttpClient, linker: Linker) {
  return (
    resource: Resource,
    project: Identifiable<Project>,
    role: Identifiable<Role>,
  ) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<ProjectResource>>>({
        endpoint: "/projects/add-non-existent-resource",
        method: HttpMethods.POST,
        data: {
          project: { uuid: project.uuid },
          role: { uuid: role.uuid },
          resource,
        },
      })
      .then((projectResource) => ({
        ...projectResource,
        project,
        resource: { ...projectResource.resource, ...resource },
        role,
      }));
}

export { saveProjectResource };
